import { colors } from "@mui/material";
import { blue } from "@mui/material/colors";

// VARIABLES DE ESTILOS
export const borderRadius = 10;
export const colorCotton = '#FFA0B4';
export const borderColorCotton = '#FF4069'; 
export const borderColorSintetico = '#059BFF';
export const borderColorVentas = '#1f9e38';
export const colorSintetico = '#82CDFF';
export const heightKPI = '150'


export const getScales = (config) => {
    return config.theme === 'Light' ? {
        y: {
            min: 0,
            stacked: true,
            ticks: {
                color: 'black',
            }
        },
        x: {
            ticks: {
                color: 'black',
            }
        }
    }
        :
        {
            y: {
                min: 0,
                stacked: true,
                ticks: {
                    color: 'white',
                }
            },
            x: {
                ticks: {
                    color: 'white',
                }
            }
        }
}

export const getTitle = (config) => {
    // console.log(config);
    return config.theme === 'Light' ? 'black' : 'white';
}


// FORMATEO
export const formateoNumber = (n) => {
    return n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

export const footer = (tooltipItems) => {
    if (!Number.isNaN(tooltipItems[0].raw / (tooltipItems[0].raw + tooltipItems[1].raw) * 100) && !Number.isNaN(tooltipItems[1].raw / (tooltipItems[0].raw + tooltipItems[1].raw) * 100)) {
        return 'Total: ' + formateoNumber((tooltipItems[0].raw + tooltipItems[1].raw)) +
            '\nCotton: ' + formateoNumber(tooltipItems[0].raw / (tooltipItems[0].raw + tooltipItems[1].raw) * 100) + '%' +
            '\nPoly: ' + formateoNumber(tooltipItems[1].raw / (tooltipItems[0].raw + tooltipItems[1].raw) * 100) + '%'
    } else {
        if (Number.isNaN(tooltipItems[0].raw / (tooltipItems[0].raw + tooltipItems[1].raw) * 100) && Number.isNaN(tooltipItems[1].raw / (tooltipItems[0].raw + tooltipItems[1].raw) * 100)) {
            return 'Total: ' + formateoNumber((tooltipItems[0].raw + tooltipItems[1].raw)) +
                '\nCotton: 0.00%' +
                '\nPoly: 0.00%'
        }
        if (!Number.isNaN(tooltipItems[1].raw / (tooltipItems[0].raw + tooltipItems[1].raw) * 100)) {
            return 'Total: ' + formateoNumber((tooltipItems[0].raw + tooltipItems[1].raw)) +
                '\nCotton: ' + formateoNumber(tooltipItems[0].raw / (tooltipItems[0].raw + tooltipItems[1].raw) * 100) + '%' +
                '\nPoly: 0.00%'
        }
        if (!Number.isNaN(tooltipItems[0].raw / (tooltipItems[0].raw + tooltipItems[1].raw) * 100))
            return 'Total: ' + formateoNumber((tooltipItems[0].raw + tooltipItems[1].raw)) +
                '\nCotton: 0.00%' +
                '\nPoly: ' + formateoNumber(tooltipItems[1].raw / (tooltipItems[0].raw + tooltipItems[1].raw) * 100) + '%'
    }
}
export const footerReproccess = (tooltipItems) => {
    if (!Number.isNaN(tooltipItems[0].raw / (tooltipItems[0].raw + tooltipItems[1].raw) * 100) && !Number.isNaN(tooltipItems[1].raw / (tooltipItems[0].raw + tooltipItems[1].raw) * 100)) {
        return 'Total: ' + formateoNumber((tooltipItems[0].raw + tooltipItems[1].raw)) +
            '\nReprocess: ' + formateoNumber(tooltipItems[0].raw / (tooltipItems[0].raw + tooltipItems[1].raw) * 100) + '%' +
            '\nWash: ' + formateoNumber(tooltipItems[1].raw / (tooltipItems[0].raw + tooltipItems[1].raw) * 100) + '%'
    } else {
        if (Number.isNaN(tooltipItems[0].raw / (tooltipItems[0].raw + tooltipItems[1].raw) * 100) && Number.isNaN(tooltipItems[1].raw / (tooltipItems[0].raw + tooltipItems[1].raw) * 100)) {
            return 'Total: ' + formateoNumber((tooltipItems[0].raw + tooltipItems[1].raw)) +
                '\nReprocess: 0.00%' +
                '\nWash: 0.00%'
        }
        if (!Number.isNaN(tooltipItems[1].raw / (tooltipItems[0].raw + tooltipItems[1].raw) * 100)) {
            return 'Total: ' + formateoNumber((tooltipItems[0].raw + tooltipItems[1].raw)) +
                '\nReprocess: ' + formateoNumber(tooltipItems[0].raw / (tooltipItems[0].raw + tooltipItems[1].raw) * 100) + '%' +
                '\nWash: 0.00%'
        }
        if (!Number.isNaN(tooltipItems[0].raw / (tooltipItems[0].raw + tooltipItems[1].raw) * 100))
            return 'Total: ' + formateoNumber((tooltipItems[0].raw + tooltipItems[1].raw)) +
                '\nReprocess: 0.00%' +
                '\nWash: ' + formateoNumber(tooltipItems[1].raw / (tooltipItems[0].raw + tooltipItems[1].raw) * 100) + '%'
    }
}

export const datalabelsBar = {
    font: {
        weight: 'bold'
    },
    color: '#FFF',
    formatter: (value, context) => {
        // console.log(value, context)
        // console.log(context.dataset.label.includes('Porcentaje') + 'asf');
        if (context.dataset.label.includes('Porcentaje')) {
            return ''
        } else {
            // console.log(context)
            return context.dataset.label + ': ' + value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' Kg'
        }
    },
}
export const datalabelsBarTop = {
    font: {
        weight: 'bold'
    },
    marginButtom: 10,
    offset: 5,
    color: '#333',
    align: 'end',
    formatter: (value, context) => {
        // console.log(value, context)
        // console.log(context.dataset.label.includes('Porcentaje') + 'asf');
        if (context.dataset.label.includes('Porcentaje')) {
            return ''
        } else {
            // console.log(context)
            return context.dataset.label + ': ' + value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }
    },
}

export const datalabelsLine = {
    borderRadius: 4,
    align: 'end',
    anchor: 'end',
    // borderWidth: 2,
    marginButtom: 10,
    color: 'white',
    padding: 6,
    offset: 5,
    font: {
        weight: 'light'
    },
    backgroundColor: function (context) {
        return context.dataset.backgroundColor;
    },
    formatter: (value, context) => {
        if (context.dataset.label.includes('Porcentaje')) {
            return ''
        } else {
            return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' kg'
        }
    },
}
export const datalabelsLineVentas = {
    borderRadius: 4,
    align: 'end',
    anchor: 'end',
    // borderWidth: 2,
    marginButtom: 10,
    color: 'white',
    padding: 6,
    offset: 5,
    font: {
        weight: 'light'
    },
    backgroundColor: function (context) {
        const fechaAcual = new Date();
        if (fechaAcual.getMonth() + 1 === context.dataIndex) {
            // console.log('si cumple');
            if (context.datasetIndex === 1) {
                return colors.blue[800];
            } else {
                return colors.pink[600]
            }
        } else {
            return context.dataset.backgroundColor;
        }
    },
    formatter: (value, context) => {
        if (context.dataset.label.includes('Porcentaje')) {
            return ''
        } else {
            return '$ ' + value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }
    },
}

export const labelPosition = (context) => {
    if (context.datasetIndex !== 1) {
        return 'end'
    }
}
    export const datalabelsLineGerencia = {
        borderRadius: 4,
        align: labelPosition,
        anchor: labelPosition,
        borderWidth: 2,
        marginButtom: 10,
        padding: 6,
        offset: 5,
        font: {
            weight: 'bold',
            size: 11
        },
        color: (context) => {
            const fechaAcual = new Date();
            if (fechaAcual.getMonth() === context.dataIndex) {
                if (context.datasetIndex === 1) {
                    return colors.indigo[900];
                } else {
                    return '#FFF'
                }
            } 
            if (context.datasetIndex === 1) {
                return '#FFF'
            } else {
                return colors.pink[600]
            }
        },
        backgroundColor: function (context) {
            const fechaAcual = new Date();
            if (fechaAcual.getMonth() === context.dataIndex) {
                // console.log('si cumple');
                if (context.datasetIndex === 1) {
                    // return colors.blue[800];
                } else {
                    return colors.pink[600]
                }
            } else {
                // return context.dataset.backgroundColor;
            }
        },
        formatter: (value, context) => {
            if (value === 0 || value === null) {
                return null
            }
            return "$ " + (value / 1000000).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " M"
        },
    }

    export const getRangeWeek = (dates) => {
        const startDate = new Date(dates.getFullYear(), 0, 1);
        const days = Math.floor((dates - startDate) /
            (24 * 60 * 60 * 1000));

        const weekNumber = parseInt(days / 7) + 1

        const data = {
            week1: weekNumber,
            week2: weekNumber,
            year1: dates.getFullYear(),
            year2: dates.getFullYear()
        }
        return data;
    }


export const datalabelsGerencia = {
    borderRadius: 4,
    align: labelPosition,
    anchor: labelPosition,
    borderWidth: 2,
    marginButtom: 10,
    padding: 6,
    offset: 5,
    font: {
        weight: 'bold',
        size:11
    },
    
    formatter: (value, context) => {
        if (value === 0 || value === null) {
            return null
        }
        return "$ " + (value / 1000).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " K"
    },
}

export const datalabelsGerencia2 = {
    borderRadius: 4,
    align: labelPosition,
    anchor: labelPosition,
    borderWidth: 2,
    marginButtom: 10,
    padding: 6,
    offset: 5,
    font: {
        weight: 'bold',
        size:11
    },
    color: (context) => {
        if (context.datasetIndex === 1) {
            return colors.indigo[900];
        }

        if (context.datasetIndex === 0) {
            return colors.pink[600]
        } 
    },
    
    formatter: (value) => {
        if (value === 0 || value === null) {
            return null
        }
        return "$ " + (value / 1000000).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " M"
    },
}

export const datalabelsLineTintoreria = {
    borderRadius: 4,
    align: labelPosition,
    anchor: labelPosition,
    borderWidth: 2,
    marginButtom: 10,
    padding: 6,
    offset: 5,
    font: {
        weight: 'bold',
        size: 10
    },
    color: (context) => {
        const fechaAcual = new Date();
        if (fechaAcual.getMonth() === context.dataIndex) {
            if (context.datasetIndex === 1) {
                return colors.indigo[900];
            } else {
                return '#FFF'
            }
        } 
        if (context.datasetIndex === 1) {
            return '#FFF'
        } else {
            return colors.pink[600]
        }
    },
    backgroundColor: function (context) {
        const fechaAcual = new Date();
        if (fechaAcual.getMonth() === context.dataIndex) {
            // console.log('si cumple');
            if (context.datasetIndex === 1) {
                // return colors.blue[800];
            } else {
                return colors.pink[600]
            }
        } else {
            // return context.dataset.backgroundColor;
        }
    },
    formatter: (value, context) => {
        if (value === 0 || value === null) {
            return null
        }
        return (value / 1000).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "K (Kg)"
    },
}


export const datalabelsCantidadPersonas = {
    borderRadius: 4,
    align: labelPosition,
    anchor: labelPosition,
    borderWidth: 2,
    marginButtom: 10,
    padding: 6,
    offset: 5,
    font: {
        weight: 'bold',
        size: 11
    },

    formatter: (value, context) => {
        if (value === 0 || value === null) {
            return null
        }
        return value
    },
}

export const datalabelsProduccion = {
    borderRadius: 4,
    align: labelPosition,
    anchor: labelPosition,
    borderWidth: 2,
    marginButtom: 10,
    padding: 6,
    offset: 5,
    font: {
        weight: 'bold',
        size:11
    },
    color: (context) => {
        if (context.datasetIndex === 1) {
            return '#FFF'
        } else {
            return colors.pink[600]
        }
    },
    
    formatter: (value, context) => {
        if (value === 0 || value === null) {
            return null
        }
        return  (value / 1000).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " K (Kg)"
    },
}

export const datalabelsLineCat = {
    borderRadius: 4,
    align: labelPosition,
    anchor: labelPosition,
    borderWidth: 2,
    marginButtom: 10,
    padding: 6,
    offset: 5,
    font: {
        weight: 'bold',
        size: 11
    },
    color: (context) => {
        const fechaAcual = new Date();
        if (context.datasetIndex === 1) {
            return '#FFF'
        } else {
            return colors.pink[700]
        }
    },
    formatter: (value, context) => {
        if (value === 0 || value === null) {
            return null
        }
        return (value / 1000).toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "K (Kg)"
    },
}

export const datalabelsVentasCotton =  {
    borderRadius: 4,
    align: labelPosition,
    anchor: labelPosition,
    borderWidth: 2,
    marginButtom: 10,
    padding: 6,
    offset: 5,
    font: {
        weight: 'bold',
        size:11
    },
    color: (context) => {
        if (context.datasetIndex === 1) {
            return 'black'
        } else {
            return colors.pink[800]
        }
    },
    
    formatter: (value) => {
        if (value === 0 || value === null) {
            return null
        }
        return "$ " + (value / 1000000).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " M"
    },
}